var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"security-tip space-between",class:[_vm.displayLayout, _vm.isNewClass]},[_c('span',{staticClass:"iconfont icon-bg-security"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }